import styled from "styled-components";

import { blue, grayScale } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";

const INDENT_SIZE = 49;

export const Container = styled.div`
  display: flex;
  gap: 9px;

  width: 100%;
  padding-left: ${INDENT_SIZE}px;
`;

export const ContentWrapper = styled.div`
  position: relative;

  width: 100%;
`;

export const WriterAndTime = styled.div`
  display: flex;
  gap: 4px;
`;

export const Writer = styled(Typo.Text)`
  color: ${grayScale[900]};
  font-weight: 600;
`;

export const Time = styled(Typo.Text)`
  color: ${grayScale[500]};
`;

export const CommentContent = styled(Typo.Text)`
  margin-top: 4px;

  color: ${grayScale[900]};
  white-space: pre-wrap;
  word-break: break-word;

  & > a {
    color: ${blue.main};
    text-decoration: underline;
  }
`;

export const IconWrapper = styled.span<{ $size: number }>`
  display: inline-block;

  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;

  transform: rotateX(180deg) scaleX(-1);
`;

export const MenuIconWrapper = styled(IconWrapper)<{ $shouldShow: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  display: ${({ $shouldShow }) => ($shouldShow ? "block" : "none")};

  cursor: pointer;
`;
